import React from "react";

const APP_URL = "nclood://";

function PaymentSuccessPage() {
  return (
    <div className="container mx-auto px-4 py-10 flex flex-col items-center justify-center">
      <h1 className="text-2xl font-semibold mb-4">Payment successful</h1>
      <p className="mb-4">Thank you! Your payment has been processed successfully.</p>
      <a
        href={APP_URL}
        className="flex h-10 items-center justify-center rounded-lg bg-purple-600 px-4 text-sm font-medium text-white"
      >
        Go to Home
      </a>
    </div>
  );
}

export default PaymentSuccessPage;
